import {Button} from 'primereact/button'
import {forwardRef} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {upperCase} from '../../utils/CommonUtils'

const FormHeader = forwardRef(
    ({header = '', onHide = () => {}, hideMargin}, ref) => {
        const {translateDatatable} = TranslateUtils()
        return !!header ? (
            <div
                className={`custom-form-header px-2 flex justify-content-between align-items-center ${
                    !hideMargin && ''
                } `}>
                <div>
                    <h3 className="mb-0  font-bold text-teal-600">
                        <strong>{upperCase(header)}</strong>
                    </h3>
                </div>
                <Button
                    icon="pi pi-arrow-left "
                    label={translateDatatable('Back')}
                    onClick={() => onHide()}
                    className="ml-2 px-5 py-[10px] text-lg font-semibold border-0"
                />
            </div>
        ) : null
    },
)

export default FormHeader
